(function () {
	const lookbookSwipers = document.querySelectorAll(".lookbook__swiper");

	const initLookbook = () => {
		gsap.registerPlugin(ScrollTrigger);

		const slidesAll =
			document.currentScript.parentElement.querySelectorAll(".lookbook__slide");

		const thisWrapper =
			document.currentScript.parentElement.querySelector(".lookbook__wrapper");

		const thisPin =
			document.currentScript.parentElement.querySelector(".lookbook__slides");

		// Calculate the total width of all slides
		const slides = gsap.utils.toArray(slidesAll);

		let maxWidth = 0;

		slides.forEach((slide) => {
			maxWidth += slide.offsetWidth;
		});

		// Horizontal scroll controlled by vertical page scroll
		gsap.to(slides, {
			x: () => `-${maxWidth - window.innerWidth}`,
			ease: "none",
			scrollTrigger: {
				trigger: thisWrapper,
				pin: thisPin,
				scrub: 1,
				start: "top top",
				end: () => `+=${maxWidth - window.innerWidth}`,
				invalidateOnRefresh: true,
			},
		});
	};

	const resizeLookbook = () => {
		const lookbookSection = document.querySelector(".section-lookbook");

		if (!lookbookSection) return;

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			// Keep the mobile viewport height variable
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty("--vh", `${vh}px`);

			// We no longer initialize Swiper on mobile.
			// Mobile uses the same GSAP horizontal scroll
			// behavior as desktop.
		});

		sectionResizeObserver.observe(lookbookSection);
	};

	resizeLookbook();
	initLookbook();

	document.addEventListener("shopify:section:load", function () {
		resizeLookbook();
		initLookbook();
	});

	document.addEventListener("shopify:section:reorder", function () {
		resizeLookbook();
		initLookbook();
	});
})();
